import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, computed } from 'vue';
import { androidPort, versionCompare, appPort } from '@/widget';
export default /*#__PURE__*/ _defineComponent({
    props: {
        fixed: {
            default: false,
            type: Boolean
        },
        perch: {
            default: false,
            type: Boolean
        },
        background: {
            type: String,
            default: 'white'
        }
    },
    setup(__props) {
        const props = __props;
        // 手机顶部状态展示
        let barH = ref(Number(window.barHeight || 0));
        if (!barH.value) {
            if (androidPort() && appPort() && versionCompare('8.2.0')) {
                barH.value = window.JavaScriptInterface.getStatusBarHeight();
            }
            else {
                barH.value = 44;
            }
        }
        const styleClass = computed(() => {
            return {
                [`${props.background}-bg`]: props.background,
                fixed: props.fixed
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "appTopBarWrapper",
                style: _normalizeStyle({ height: __props.perch ? _unref(barH) + 'px' : 0 + 'px' })
            }, [
                _createElementVNode("div", {
                    style: _normalizeStyle({ height: _unref(barH) + 'px' }),
                    class: _normalizeClass({ ..._unref(styleClass) })
                }, null, 6)
            ], 4));
        };
    }
});
